module.exports = __webpack_public_path__ + "5073e7feba8b68ada1dd46f8dbb850a1.pdf";